/*
  Produtos recomendados da pagina de rastreio, no visual da Vitrine Match Day.

  O bloco "You may also like..." e um carrossel Swiper do proprio ParcelPanel: outro
  markup, outra tipografia, foto esticada, carrossel que anda sozinho. Em vez de
  maquiar o Swiper com CSS (o app reescreve largura e margem dos slides por JS, entao
  qualquer numero nosso brigaria com o dele), este script REMONTA o bloco com o markup
  do tema - o mesmo <div class="md-carrossel"> + cartao do snippet md-card-produto que
  a Vitrine usa na home.

  Isso e possivel porque md-carrossel.css, md-card-produto.css e md-carrossel.js sao
  carregados em TODA pagina pelo theme.liquid: o visual e o motor do carrossel (barra
  de progresso arrastavel, setas, encaixe, arraste com o mouse) ja estao aqui. O que
  falta e so o markup - e os dados, que vem dos proprios cartoes do app.

  Consequencia boa: o dia em que o cartao do tema mudar, este bloco muda junto, porque
  ele NAO tem estilo proprio - usa as classes do tema.

  Se o app trocar os nomes de classe, o script nao acha nada e sai quieto: o bloco
  original do ParcelPanel continua no ar como sempre esteve.
*/
(function () {
  'use strict';

  var MARCA = 'data-md-vitrine';
  var ID_BLOCO = 'md-vitrine-rastreio';

  /* ---------- dinheiro ---------- */

  /* "$1,234.56" -> 1234.56 ; devolve null quando nao ha numero */
  function paraNumero(txt) {
    if (!txt) return null;
    var limpo = String(txt).replace(/[^\d.,]/g, '');
    limpo = limpo.replace(/,(\d{3}\b)/g, '$1').replace(',', '.');
    var n = parseFloat(limpo);
    return isNaN(n) ? null : n;
  }

  /*
    Escreve um valor no mesmo formato do preco que veio do app: pega o que nao e numero
    no modelo (o "$", ou "R$", ou " EUR") e recoloca na mesma posicao. Sem centavos
    quando o valor e redondo, que e o que o SAVE da vitrine faz na home
    (filtro money_without_trailing_zeros).
  */
  function comoDinheiro(valor, modelo) {
    var antes = (String(modelo).match(/^[^\d]*/) || [''])[0];
    var depois = (String(modelo).match(/[^\d]*$/) || [''])[0];
    var corpo = valor % 1 === 0 ? String(valor) : valor.toFixed(2);
    return antes + corpo + depois;
  }

  /* ---------- leitura dos cartoes do app ---------- */

  function lerProdutos(swiper) {
    var vistos = {};
    var lista = [];
    var slides = swiper.querySelectorAll('.swiper-slide');

    for (var i = 0; i < slides.length; i++) {
      var s = slides[i];
      var link = s.querySelector('a.product__anchor') || s.querySelector('a');
      var img = s.querySelector('img.product__img') || s.querySelector('img');
      var titulo = s.querySelector('.product__title');
      var preco = s.querySelector('.product__price');
      var antigo = s.querySelector('.product__compare_price');
      if (!link || !img || !titulo || !preco) continue;

      /* o loop do Swiper duplica os slides - a chave mata o clone */
      var chave = link.getAttribute('href') + '|' + titulo.textContent;
      if (vistos[chave]) continue;
      vistos[chave] = true;

      lista.push({
        href: link.getAttribute('href'),
        alvo: link.getAttribute('target') || '',
        foto: img.getAttribute('src'),
        alt: img.getAttribute('alt') || '',
        titulo: titulo.textContent.trim(),
        preco: preco.textContent.trim(),
        antigo: antigo ? antigo.textContent.trim() : ''
      });
    }
    return lista;
  }

  /* ---------- montagem no markup do tema ---------- */

  var LARGURAS = [215, 297, 430, 594, 800];
  var MEDIDAS = '(min-width: 1024px) 16vw, (min-width: 768px) 29vw, 67vw';

  /* a foto do app vem numa largura so; o CDN da Shopify aceita &width= */
  function comLargura(url, w) {
    if (!url) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function montarCard(p) {
    var card = document.createElement('div');
    card.className = 'md-card';

    var midia = document.createElement('div');
    midia.className = 'md-card__midia';

    var capa = document.createElement('a');
    capa.className = 'md-card__capa-link';
    capa.href = p.href;
    if (p.alvo) {
      capa.target = p.alvo;
      capa.rel = 'noopener noreferrer';
    }
    capa.setAttribute('aria-hidden', 'true');
    capa.tabIndex = -1;
    midia.appendChild(capa);

    var img = document.createElement('img');
    img.className = 'md-card__foto';
    img.src = comLargura(p.foto, 800);
    img.srcset = LARGURAS.map(function (w) {
      return comLargura(p.foto, w) + ' ' + w + 'w';
    }).join(', ');
    img.sizes = MEDIDAS;
    img.loading = 'lazy';
    img.decoding = 'async';
    img.alt = p.alt;
    midia.appendChild(img);

    var pAtual = paraNumero(p.preco);
    var pAntigo = paraNumero(p.antigo);
    var emPromo = pAtual !== null && pAntigo !== null && pAntigo > pAtual;

    /*
      Selo de desconto na mesma regra da vitrine: percentual arredondado e SAVE sem
      centavos. Aqui ele nasce da conta entre os dois precos do proprio app, porque a
      pagina do app nao expoe preco de comparacao em dado estruturado.
      Nao ha selo "Pro" nem "SOLD OUT": o app nao diz se o produto e modelo jogador e
      so recomenda produto disponivel.
    */
    if (emPromo) {
      var economia = Math.round((pAntigo - pAtual) * 100) / 100;
      var percentual = Math.round((economia * 100) / pAntigo);
      var selos = document.createElement('div');
      selos.className = 'md-card__selos';
      var selo = document.createElement('span');
      selo.className = 'md-card__selo md-card__selo--promo';
      selo.textContent = percentual + '% OFF | SAVE ' + comoDinheiro(economia, p.preco);
      selos.appendChild(selo);
      midia.appendChild(selos);
    }

    var texto = document.createElement('div');
    texto.className = 'md-card__texto';

    var h3 = document.createElement('h3');
    h3.className = 'md-card__titulo';
    var linkTitulo = document.createElement('a');
    linkTitulo.className = 'md-card__titulo-link';
    linkTitulo.href = p.href;
    if (p.alvo) {
      linkTitulo.target = p.alvo;
      linkTitulo.rel = 'noopener noreferrer';
    }
    linkTitulo.textContent = p.titulo;
    h3.appendChild(linkTitulo);
    texto.appendChild(h3);

    var precos = document.createElement('div');
    precos.className = 'md-card__precos';
    var atual = document.createElement('span');
    atual.className = 'md-card__preco' + (emPromo ? ' md-card__preco--promo' : '');
    atual.textContent = p.preco;
    precos.appendChild(atual);
    if (emPromo) {
      var velho = document.createElement('s');
      velho.className = 'md-card__preco-antigo';
      velho.textContent = p.antigo;
      precos.appendChild(velho);
    }
    texto.appendChild(precos);

    card.appendChild(midia);
    card.appendChild(texto);
    return card;
  }

  function montarBloco(titulo, produtos) {
    var faixa = document.createElement('div');
    faixa.className = 'md-vitrine md-vitrine--rastreio';
    faixa.id = ID_BLOCO;

    var car = document.createElement('div');
    car.className = 'md-carrossel';
    car.setAttribute('data-md-carrossel', '');

    if (titulo) {
      var h2 = document.createElement('h2');
      h2.className = 'md-carrossel__titulo';
      h2.textContent = titulo;
      car.appendChild(h2);
    }

    var trilho = document.createElement('ul');
    trilho.className = 'md-carrossel__trilho';
    trilho.setAttribute('data-md-trilho', '');
    trilho.setAttribute('role', 'list');
    if (titulo) trilho.setAttribute('aria-label', titulo);

    produtos.forEach(function (p) {
      var li = document.createElement('li');
      li.className = 'md-carrossel__item';
      li.appendChild(montarCard(p));
      trilho.appendChild(li);
    });
    car.appendChild(trilho);

    /* controles identicos aos da section: o md-carrossel.js liga tudo pelos data- */
    var controles = document.createElement('div');
    controles.className = 'md-carrossel__controles';
    controles.innerHTML =
      '<div class="md-carrossel__barra">' +
      '<div class="md-carrossel__trilha" data-md-trilha><div class="md-carrossel__fita" data-md-fita></div></div>' +
      '</div>' +
      '<div class="md-carrossel__setas">' +
      '<button type="button" class="md-carrossel__seta" data-md-seta="-1" aria-label="Slide left">' +
      '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="M12.5 4.5 7 10l5.5 5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '<button type="button" class="md-carrossel__seta" data-md-seta="1" aria-label="Slide right">' +
      '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="M7.5 4.5 13 10l-5.5 5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '</div>';
    car.appendChild(controles);

    faixa.appendChild(car);
    return faixa;
  }

  /*
    A faixa sangra ate a borda da tela, como na home. 100vw sozinho contaria a barra de
    rolagem e criaria rolagem horizontal no Windows, entao a largura util vem medida do
    documento e volta como variavel.

    A medida e refeita por ResizeObserver no <html>, e nao so no resize da janela: a
    barra de rolagem vertical aparece DEPOIS, quando o conteudo do app termina de
    montar, e nesse instante a largura util encolhe ~15px. Medindo uma vez so, a faixa
    ficaria mais larga que a pagina e abriria rolagem horizontal.
  */
  function medirLargura() {
    var faixa = document.getElementById(ID_BLOCO);
    if (!faixa) return;
    faixa.style.setProperty('--md-vw', document.documentElement.clientWidth + 'px');
  }

  /* ---------- troca ---------- */

  function trocar() {
    var swiper = document.querySelector('.pp_recommend_product_parent:not([' + MARCA + '])');
    if (!swiper) return false;

    var produtos = lerProdutos(swiper);
    if (!produtos.length) return false;

    var tituloEl = document.querySelector('.pp_recommend_title');
    var titulo = tituloEl ? tituloEl.textContent.trim() : '';

    /* para o autoplay e solta os ouvintes do Swiper antes de tirar o bloco da tela */
    try {
      if (swiper.swiper && typeof swiper.swiper.destroy === 'function') {
        swiper.swiper.destroy(true, false);
      }
    } catch (e) {}

    var antigo = document.getElementById(ID_BLOCO);
    if (antigo && antigo.parentNode) antigo.parentNode.removeChild(antigo);

    var bloco = montarBloco(titulo, produtos);
    swiper.setAttribute(MARCA, '1');
    swiper.style.display = 'none';
    if (tituloEl) {
      tituloEl.setAttribute(MARCA, '1');
      tituloEl.style.display = 'none';
    }
    swiper.parentNode.insertBefore(bloco, swiper);

    medirLargura();

    /*
      O motor do carrossel varre no DOMContentLoaded e no shopify:section:load. Este
      bloco nasce depois, entao o evento e disparado A PARTIR DELE: o ouvinte do tema
      chama varrer(e.target) e inicializa so o que esta aqui dentro.
    */
    bloco.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
    return true;
  }

  function tentar() {
    try {
      return trocar();
    } catch (e) {
      return false;
    }
  }

  tentar();

  /* o app monta o bloco depois da resposta da API, e remonta a cada nova consulta */
  if (window.MutationObserver) {
    var agendado = null;
    var obs = new MutationObserver(function () {
      if (agendado) return;
      agendado = setTimeout(function () {
        agendado = null;
        tentar();
      }, 120);
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  window.addEventListener('resize', medirLargura);

  if (window.ResizeObserver) {
    new ResizeObserver(medirLargura).observe(document.documentElement);
  }
})();
